import { distanceKm } from "./api";

const COMPASS = [
  "N",
  "NNE",
  "NE",
  "ENE",
  "E",
  "ESE",
  "SE",
  "SSE",
  "S",
  "SSW",
  "SW",
  "WSW",
  "W",
  "WNW",
  "NW",
  "NNW",
];

const COMPASS_WORDS = [
  "north",
  "north-northeast",
  "northeast",
  "east-northeast",
  "east",
  "east-southeast",
  "southeast",
  "south-southeast",
  "south",
  "south-southwest",
  "southwest",
  "west-southwest",
  "west",
  "west-northwest",
  "northwest",
  "north-northwest",
];

const point = (deg) => Math.round((((deg % 360) + 360) % 360) / 22.5) % 16;

export const compass = (deg) => COMPASS[point(deg)];
export const compassWords = (deg) => COMPASS_WORDS[point(deg)];
export const toKmh = (metersPerSecond) => metersPerSecond * 3.6;

// Below this the direction is not meaningful
export const CALM_MS = 0.5;

// Wind further than this from any weather station is not estimated
const MAX_DISTANCE_KM = 50;
const NEAREST = 4;

// Inverse-distance weighted average of the nearest stations' wind vectors.
// Returns { speed (m/s), towards (deg), from (deg) } or null when no station
// is close enough.
export const windAt = (lat, lon, weather) => {
  const near = weather
    .map((w) => ({ w, distance: distanceKm(lat, lon, w.lat, w.lon) }))
    .filter((n) => n.distance <= MAX_DISTANCE_KM)
    .sort((a, b) => a.distance - b.distance)
    .slice(0, NEAREST);
  if (near.length === 0) return null;

  let east = 0;
  let north = 0;
  let total = 0;
  near.forEach(({ w, distance }) => {
    const weight = 1 / Math.max(distance, 0.5) ** 2;
    const towards = ((w.direction + 180) * Math.PI) / 180;
    east += weight * w.speed * Math.sin(towards);
    north += weight * w.speed * Math.cos(towards);
    total += weight;
  });
  east /= total;
  north /= total;

  const towards = ((Math.atan2(east, north) * 180) / Math.PI + 360) % 360;
  return {
    speed: Math.hypot(east, north),
    towards,
    from: (towards + 180) % 360,
  };
};
